import { render, staticRenderFns } from "./ProjecaoAplicada.vue?vue&type=template&id=00708e94"
import script from "./ProjecaoAplicada.vue?vue&type=script&lang=js"
export * from "./ProjecaoAplicada.vue?vue&type=script&lang=js"
import style0 from "./ProjecaoAplicada.vue?vue&type=style&index=0&id=00708e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports